import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  statusWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    background: theme.palette.text.white,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3, 4),
  },
  draftState: {
    fontWeight: 500,
    color: theme.palette.labraText.tertiary,
  },
  status: {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(3),
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '28px',
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  btnDisabled: {
    pointerEvents: 'none',
    opacity: '39%',
  },
  modalText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    width: theme.spacing(52.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    '& p': {
      margin: 0,
    },
  },
  descriptionNote: {
    fontWeight: 600,
    fontSize: '14px',
  },
  rowRightItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(5, 1, 0, 0),
    height: theme.spacing(5),
  },
  channelOffer: {
    minWidth: theme.spacing(24.5),
    display: 'flex',
  },
  moreMenu: {
    color: theme.palette.select.light,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
  },
  errorSubContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  offerUpdatedAt: {
    fontSize: '11px',
    fontWeight: 500,
    color: theme.palette.labraText.description,
    lineHeight: '16px',
  },
  btnLink: {
    padding: `${theme.spacing(0, 0.5)} !important`,
    minHeight: `${theme.spacing(2)} !important`,
    border: 0,
  },
  linkItem: {
    padding: `${theme.spacing(0, 0.5)} !important`,
    minHeight: `${theme.spacing(2)} !important`,
    border: 0,
    fontWeight: '500 !important',
    fontSize: '14px !important',
    lineHeight: '20px !important',
  },
  noStatusBar: {
    display: 'none',
  },
}))
